module.exports = __webpack_public_path__ + "img/cover.13ff54f0.jpg";